import {
  MessageDotsIcon,
  MessageIcon,
  RightArrowIcon
} from '@/components/common/icon';
import { useTimModalStore } from '@/tim/useTimModalStore';
import { useTranslation } from 'react-i18next';

export default function MessageButton({
  order,
  timUnreadCount,
  className,
  isModule = false,
  isText = false,
  isIcon = false,
  showIcon = true
}: {
  order: any;
  timUnreadCount: number;
  className?: string;
  isModule?: boolean;
  isText?: boolean;
  isIcon?: boolean;
  showIcon?: boolean;
}) {
  const { t } = useTranslation();
  const { setShowTimModal } = useTimModalStore();
  const orderId = order?._id || order?.id;

  const handleMessage = () => {
    setShowTimModal(true, {
      campaignId: order?.campaignId,
      orderId
    });
  };

  if (isIcon) {
    return (
      <div
        className={`w6 h-6 flex items-center justify-center cursor-pointer flex-shrink-0 relative gap-1 ${className}`}
        onClick={handleMessage}
      >
        <div className="h-4 border-l border-[#E7E5E4]"></div>
        <MessageDotsIcon className="w-6 h-6 text-[#A9A29D]" />
        {timUnreadCount > 0 && (
          <div className="absolute right-[-8px] top-[-8px] min-w-[18px] h-[18px] rounded-full bg-[#ff4d4f] px-1 text-white text-[12px] flex items-center justify-center">
            {timUnreadCount > 99 ? '99+' : timUnreadCount}
          </div>
        )}
      </div>
    );
  }

  if (isText) {
    return (
      <span
        className={`text-sm font-medium text-[#FF621D] cursor-pointer whitespace-nowrap ${className}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleMessage();
        }}
      >
        {t('detail.need_help_message_brand', {
          defaultValue: 'Need help? Message brand'
        })}
      </span>
    );
  }

  if (isModule) {
    return (
      <div
        className={`w-full flex items-center gap-3 rounded-2xl bg-white px-6 py-3 border border-[#E7E5E4] cursor-pointer relative ${className}`}
        onClick={handleMessage}
      >
        <div className="w-10 h-10 rounded-xl bg-[#FFF0E6] flex items-center justify-center flex-shrink-0">
          <MessageIcon className="w-5 h-5 text-[#FB6011]" />
        </div>
        <div className="flex-1 min-w-0 flex flex-col gap-0.5">
          <div className="text-[#1C1917] text-sm font-semibold font-['DM_Sans'] leading-5">
            {t('detail.message_brand_btn', {
              defaultValue: 'Message brand'
            })}
          </div>
          <div className="text-[#79716B] text-xs font-normal font-['DM_Sans'] leading-4">
            {t('detail.message_brand_desc', {
              defaultValue: 'Chat about this deal'
            })}
          </div>
        </div>
        <RightArrowIcon className="w-5 h-5 text-[#A9A29D] flex-shrink-0" />
        {timUnreadCount > 0 && (
          <div className="absolute right-2 top-2 min-w-[18px] h-[18px] rounded-full bg-[#ff4d4f] px-1 text-white text-[12px] flex items-center justify-center">
            {timUnreadCount > 99 ? '99+' : timUnreadCount}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={`h-[40px] flex items-center justify-center text-[#44403C] text-sm font-semibold gap-1 border rounded-md px-[14px] border-[#D7D3D0] cursor-pointer relative w-full md:w-auto ${className}`}
      onClick={handleMessage}
    >
      <div className="flex items-center gap-2">
        {showIcon && <MessageIcon className="" />}
        <div className="justify-start font-['DM_Sans'] leading-5">
          {t('detail.message_brand_btn', {
            defaultValue: 'Message brand'
          })}
        </div>
      </div>
      {timUnreadCount > 0 && (
        <div className="absolute right-[-8px] top-[-8px] min-w-[18px] h-[18px] rounded-full bg-[#ff4d4f] px-1 text-white text-[12px] flex items-center justify-center">
          {timUnreadCount > 99 ? '99+' : timUnreadCount}
        </div>
      )}
    </div>
  );
}
